// @flow
import type {
  CertRequestData,
  CertUpload,
  Dispatch,
  GetState,
} from 'state/types';
import { getAdminSession, getCertRequestData, getPorts } from 'state/selectors';
import {
  createCertRequest as createCertRequestAction,
  deleteCertRequest as deleteCertRequestAction,
  getCertStatus as getCertStatusAction,
  uploadCert as uploadCertAction,
} from 'state/reducers/certReducer';
import localizedStrings from 'util/localizedStrings';
import { getAdminAddress } from 'util/serverUtils';
import { API } from 'util/constants';
import { actions as modalPromptActions } from 'portfolio-shared/state/reducers/modalPromptReducer';
import {
  addNotification,
  ERROR_LEVEL,
  SUCCESS_LEVEL,
} from 'portfolio-shared/state/commands/globalNotificationsCommands';
const { showModalPrompt } = modalPromptActions;

export function getCertStatus() {
  return async function getCertStatus(dispatch: Dispatch, getState: GetState) {
    const session = getAdminSession(getState());
    if (session) {
      await dispatch(getCertStatusAction(session));
    }
  };
}

export function deleteCertRequest() {
  return async function deleteCertRequest(
    dispatch: Dispatch,
    getState: GetState
  ) {
    const session = getAdminSession(getState());
    const existingCertRequest = getCertRequestData(getState());
    if (session && existingCertRequest) {
      dispatch(
        showModalPrompt({
          isButton2Default: true,
          message: localizedStrings.CERT_DELETE_CONFIRMATION,
          dataTestName: 'delete-cert-request-confirmation',
          onButton2: async function dodelete() {
            await dispatch(deleteCertRequestAction(session));
            await dispatch(getCertStatusAction(session));
          },
        })
      );
    }
  };
}

export function createCertRequest(certRequest: CertRequestData) {
  return async function createCertRequest(
    dispatch: Dispatch,
    getState: GetState
  ) {
    const session = getAdminSession(getState());
    if (session) {
      const existingCertRequest = getCertRequestData(getState());
      if (existingCertRequest) {
        dispatch(
          showModalPrompt({
            isButton2Default: true,
            message: localizedStrings.CERT_REQUEST_ALREADY_CREATED_WARNING,
            dataTestName: 'replace-cert-request-confirmation',
            onButton2: async function doReplace() {
              await dispatch(createCertRequestAction(session, certRequest));
              await dispatch(getCertStatusAction(session));
            },
          })
        );
      } else {
        await dispatch(createCertRequestAction(session, certRequest));
        await dispatch(getCertStatusAction(session));
      }
    }
  };
}

export function downloadCertRequest() {
  return async function getCertRequest(dispatch: Dispatch, getState: GetState) {
    const session = getAdminSession(getState());
    if (session) {
      const ports = getPorts(getState());
      const serverAddress = getAdminAddress(ports);
      const base = `${API}/certificate/request?session=${session}`;
      const url = `${serverAddress}${base}`;
      window.location = url;
    }
  };
}

export function uploadCert(certUpload: CertUpload) {
  return async function uploadCert(dispatch: Dispatch, getState: GetState) {
    const session = getAdminSession(getState());
    if (session) {
      const formData: any = {};
      if (certUpload.mainCertFile) {
        formData.certificate = certUpload.mainCertFile;
      }
      if (certUpload.intermediateCertFile1) {
        formData.intermediate1 = certUpload.intermediateCertFile1;
      }
      if (certUpload.intermediateCertFile2) {
        formData.intermediate2 = certUpload.intermediateCertFile2;
      }
      if (certUpload.rootCertFile) {
        formData.rootCertificate = certUpload.rootCertFile;
      }
      if (certUpload.password) {
        formData.certificatePassword = certUpload.password;
      }

      let error;
      await dispatch(uploadCertAction(session, formData)).catch(e => {
        error = e;
      });
      if (error) {
        let msgId;
        if (error.faultCode === 'InvalidParameters') {
          msgId = localizedStrings.CERT_IMPORT_FAILED_READING_PKCS12;
        } else if (error.faultCode === 'UnexpectedError') {
          if (error.message === 'import intermediate 1') {
            msgId = localizedStrings.CERT_IMPORT_FAILED_INTERMEDIATE1;
          } else if (error.message === 'import intermediate 2') {
            msgId = localizedStrings.CERT_IMPORT_FAILED_INTERMEDIATE2;
          } else if (error.message === 'import root') {
            msgId = localizedStrings.CERT_IMPORT_FAILED_ROOT;
          }
        }
        dispatch(addNotification(msgId, ERROR_LEVEL));
      } else {
        dispatch(
          addNotification(localizedStrings.CERT_IMPORT_SUCCEEDED, SUCCESS_LEVEL)
        );
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/state/commands/certCommands.js